export const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms))

/**
 * @see https://github.com/vercel/next.js/issues/5354#issuecomment-520305040
 */
export const isServer = typeof window === "undefined"
export const isBrowser = !isServer

export const saveFile = (file: Blob, fileName?: string) => {
  const url = URL.createObjectURL(file)
  const a = document.createElement("a")
  a.href = url
  a.target = "_blank"
  if (fileName) {
    a.download = fileName
  } else if (file instanceof File) {
    a.download = file.name
  }

  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)

  return url
}

/**
 * 引数に与えられたPromiseが解決されるまで、ページのアンロード時に確認ダイアログを表示します。
 */
export const preventUnloadUntilPromiseSettled = <T>(asyncFn: Promise<T> | (() => Promise<T>)) => {
  const listener = (e: BeforeUnloadEvent) => {
    e.returnValue = ""
    e.preventDefault()
  }
  window.addEventListener("beforeunload", listener)
  const onFinally = () => window.removeEventListener("beforeunload", listener)

  const promise = typeof asyncFn === "function" ? asyncFn() : asyncFn
  return promise.finally(onFinally)
}
